var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarHeart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.57143 5.28577C3.11678 5.28577 2.68074 5.46638 2.35925 5.78787C2.03776 6.10936 1.85715 6.5454 1.85715 7.00005V22.4286C1.85715 22.8833 2.03776 23.3193 2.35925 23.6408C2.68074 23.9623 3.11678 24.1429 3.57143 24.1429H22.4286C22.8832 24.1429 23.3193 23.9623 23.6408 23.6408C23.9622 23.3193 24.1429 22.8833 24.1429 22.4286V7.00005C24.1429 6.5454 23.9622 6.10936 23.6408 5.78787C23.3193 5.46638 22.8832 5.28577 22.4286 5.28577H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 1.85718V8.71432",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19 1.85718V8.71432",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7 5.28577H15.5714",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13 13.8571C14.7143 10.4286 18.1429 12.1428 18.1429 14.7143C18.1429 18.1428 13 19.8571 13 19.8571C13 19.8571 7.85715 18.1428 7.85715 14.7143C7.85715 12.1428 11.2857 10.4286 13 13.8571Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar_heart.2fc09fee7c7d189c86753af17e70f269.svg";